import { ID } from './StandartId';

export const CARD = {
  MAPPED:ID.CARD+"mapped",
  UNMAPPED:ID.CARD+"unmapped",
};
